import packageInfo from '../../package.json';

export const environment = {
  production: false,
  version: packageInfo.version,
  apiServerUrl: 'https://status.avpark.ch',
  syncfusionKey: 'Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXpfcnRTRmZcUUJ0VkJWYE4=',

  apiClientId: 'AVParkStatusWeb',
  localStorageToken: 'token',
  localStorageRefreshToken: 'refreshToken',
  localStorageUserInfo: 'userInfo',
  supportedLanguages: 'en,de',
  alarmReloadInterval: 2000,
  idleTimeoutInSeconds: 300,
  localStorageActivityTimestamp: 'activityTimestamp',
  localStorageIsSidebarPinned: 'isSidebarPinned',
  envInfoClass: null, 
  allowBrowserTranslation: true
};
